import React, { useState } from "react";

function VideoOne() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const youtubeVideoId = "oc-KC5OZp34";
  const youtubeEmbedUrl = `https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&mute=1&loop=1&playlist=${youtubeVideoId}&controls=1&rel=0`;

  const handleVideoPlay = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVideoPlaying(true);
  };

  return (
    <section className="video-area space-top space-bottom">
      <div className="container">
        <div className="th-video">
          <div className="video-wrapper" style={{ paddingBottom: "56.25%", height: 0, overflow: "hidden", position: "relative" }}>
            {!isVideoPlaying ? (
              <>
                <div
                  className="video-thumbnail-bg"
                  style={{
                    backgroundImage: "url(/assets/img/yurt-fotograf/dis-cephe/33.jpg)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "absolute",
                    inset: 0,
                    zIndex: 1,
                  }}
                  role="img"
                  aria-label="Haseki Sultan Kız Öğrenci Yurdu - Dış Cephe"
                  title="Haseki Sultan Kız Öğrenci Yurdu - Dış Cephe"
                />
                <div className="video-thumbnail" onClick={handleVideoPlay}>
                  <button
                    className="video-play-btn"
                    onClick={handleVideoPlay}
                    aria-label="Play Video"
                  >
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="40" cy="40" r="40" fill="rgba(255, 255, 255, 0.9)" />
                      <path d="M32 24L32 56L56 40L32 24Z" fill="#1CA8CB" />
                    </svg>
                  </button>
                </div>
              </>
            ) : (
              <iframe
                src={youtubeEmbedUrl}
                title="Haseki Sultan Kız Öğrenci Yurdu"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="youtube-embed"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoOne;

